module.exports = __webpack_public_path__ + "static/bench-mv-open-38425e34ec187040f1a1c6354a2c3eed.jpg";